export * from './create-paper-model.req';
export * from './sections-wise-data.modal';
export * from './chapter-wise-model';